module.exports = __webpack_public_path__ + "img/雄安新区基础地质数据展示子系统.2894291f.jpg";